import { type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '../../utils';

export interface NoticeBannerProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
}

export const NoticeBanner = ({
  icon,
  title,
  description,
  className,
  role = 'status',
  ...props
}: NoticeBannerProps) => (
  <div
    role={role}
    className={cn(
      'bg-muted-foreground/5 border-border-soft flex w-full items-center gap-2 border-b px-4 py-2.5',
      className
    )}
    {...props}
  >
    {icon}
    <div className="flex min-w-0 flex-col">
      <p className="text-primary text-md font-regular leading-5">{title}</p>
      {description && (
        <p className="text-neutral-1400 text-xs leading-4">{description}</p>
      )}
    </div>
  </div>
);
